import { HTMLAttributes, ReactNode, ReactElement } from 'react'

export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode
    size?: 560 | 720 | 960
}

const Container = ({ children, size, ...rest }: ContainerProps): ReactElement => {
    const maxWidth = `${size ? size + 'px' : 'none'}`

    return (
        <div {...rest} style={{ maxWidth }} className={`mx-auto w-full px-4 md:px-0 ${rest.className || ''}`}>
            {children}
        </div>
    )
}

export default Container
